/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_RangeInputs */

const en_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Range`)
};

const es_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campo de práctica`)
};

const de_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range`)
};

const zh_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`练习场`)
};

const ar_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ميدان التدريب`)
};

const fr_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range`)
};

const vi_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sân tập`)
};

const sw_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uwanja wa mazoezi`)
};

const th_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนามไดร์ฟ`)
};

const bs_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vježbalište`)
};

const ja_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レンジ`)
};

const ko_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`드라이빙 레인지`)
};

const pt_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range`)
};

const it_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range`)
};

const sv_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const nl_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const da_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const nb_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const fi_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const pl_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const ru_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Драйвинг-рейндж`)
};

const tr_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const hi_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ड्राइविंग रेंज`)
};

const id_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const ms_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const cs_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const el_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const he_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דרייבינג ריינג'`)
};

const af_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const hu_footer_link_range = /** @type {(inputs: Footer_Link_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

/**
* | output |
* | --- |
* | "Range" |
*
* @param {Footer_Link_RangeInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const footer_link_range = /** @type {((inputs?: Footer_Link_RangeInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_RangeInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_link_range(inputs)
	if (locale === "de") return de_footer_link_range(inputs)
	if (locale === "zh") return zh_footer_link_range(inputs)
	if (locale === "ar") return ar_footer_link_range(inputs)
	if (locale === "fr") return fr_footer_link_range(inputs)
	if (locale === "vi") return vi_footer_link_range(inputs)
	if (locale === "sw") return sw_footer_link_range(inputs)
	if (locale === "th") return th_footer_link_range(inputs)
	if (locale === "bs") return bs_footer_link_range(inputs)
	if (locale === "ja") return ja_footer_link_range(inputs)
	if (locale === "ko") return ko_footer_link_range(inputs)
	if (locale === "pt") return pt_footer_link_range(inputs)
	if (locale === "it") return it_footer_link_range(inputs)
	if (locale === "sv") return sv_footer_link_range(inputs)
	if (locale === "nl") return nl_footer_link_range(inputs)
	if (locale === "da") return da_footer_link_range(inputs)
	if (locale === "nb") return nb_footer_link_range(inputs)
	if (locale === "fi") return fi_footer_link_range(inputs)
	if (locale === "pl") return pl_footer_link_range(inputs)
	if (locale === "ru") return ru_footer_link_range(inputs)
	if (locale === "tr") return tr_footer_link_range(inputs)
	if (locale === "hi") return hi_footer_link_range(inputs)
	if (locale === "id") return id_footer_link_range(inputs)
	if (locale === "ms") return ms_footer_link_range(inputs)
	if (locale === "cs") return cs_footer_link_range(inputs)
	if (locale === "el") return el_footer_link_range(inputs)
	if (locale === "he") return he_footer_link_range(inputs)
	if (locale === "af") return af_footer_link_range(inputs)
	if (locale === "hu") return hu_footer_link_range(inputs)
	return en_footer_link_range(inputs)
});